import { render, staticRenderFns } from "./mainTitle.vue?vue&type=template&id=590d0657&scoped=true&"
import script from "./mainTitle.vue?vue&type=script&lang=js&"
export * from "./mainTitle.vue?vue&type=script&lang=js&"
import style0 from "./mainTitle.vue?vue&type=style&index=0&id=590d0657&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590d0657",
  null
  
)

export default component.exports